export default "__VITE_PUBLIC_ASSET__3f797138__"